import { v4 as uuid } from 'uuid';

export default [
  {
    id: uuid(),
    nombre:'T01150920',
    tramite:'Homologación de Títulos',
    estado: 'Pendiente',
    documentos: '',
    createdAt: 1606916400000,
  },
  {
    id: uuid(),
    nombre:'T04150920',
    tramite:'Aprobación de Programas',
    estado: 'Aprobado',
    documentos: 'http://google.com',
    createdAt: 1606916400000,
  },
  {
    id: uuid(),
    nombre:'T05150920',
    tramite:'Aprobacion de Programas',
    estado: 'Aprobado',
    documentos: 'http://google.com',
    createdAt: 1606916400000,
  },
  {
    id: uuid(),
    nombre:'T06150920',
    tramite:'Homologación de Títulos',
    estado: 'Pendiente Dto Jurídico',
    documentos: '',
    createdAt: 1606916400000,
  },

  
];
